import { APP_RESIZE } from "./types";

export const handleWindowSizeChange = () => {
    return (dispatch, getState) => {
        dispatch({ type: APP_RESIZE });
    }
};
